import { Tagß, type TagßProps } from '@otter-ai/den-components';
import { useTranslations } from 'next-intl';

export type ProTagProps = Pick<TagßProps, 'size'>;

export function ProTag({ size = 'md' }: ProTagProps) {
  const t = useTranslations('settings:integrations.tags');
  return (
    <Tagß data-testid="pro-tag" size={size} color="blue">
      {t('pro')}
    </Tagß>
  );
}
